import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left-arrow",
  "use": "icon-left-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M694.475 832.453l-56.285 58.26-393.996-392.021 393.996-392.021 56.285 58.26-331.786 333.761z\" p-id=\"4059\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol